"use strict";
/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.36.1070 on 2022-04-29 11:04:51.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosRestApplicationClient = exports.RestApplicationClient = exports.FileSystemResourcePermissionMask = exports.Folder = exports.File = exports.FileInput = exports.InputFileSystemResource = exports.FileSystemResource = void 0;
class FileSystemResource {
    constructor(data) {
        this.file = data.file;
        this.folder = data.folder;
    }
}
exports.FileSystemResource = FileSystemResource;
class InputFileSystemResource {
    constructor(data) {
        this.contents = data.contents;
        this.name = data.name;
        this.path = data.path;
        this.folder = data.folder;
        this.newPermissionMask = data.newPermissionMask;
    }
}
exports.InputFileSystemResource = InputFileSystemResource;
class FileInput {
    constructor(data) {
        this.contents = data.contents;
        this.name = data.name;
    }
}
exports.FileInput = FileInput;
class File {
    constructor(data) {
        this.lastAccessTime = data.lastAccessTime;
        this.contents = data.contents;
        this.name = data.name;
        this.size = data.size;
        this.path = data.path;
        this.lastWriteTime = data.lastWriteTime;
        this.permissionMask = data.permissionMask;
    }
}
exports.File = File;
class Folder {
    constructor(data) {
        this.lastAccessTime = data.lastAccessTime;
        this.name = data.name;
        this.path = data.path;
        this.files = data.files;
        this.subfolders = data.subfolders;
        this.lastWriteTime = data.lastWriteTime;
        this.permissionMask = data.permissionMask;
    }
}
exports.Folder = Folder;
class FileSystemResourcePermissionMask {
    constructor(data) {
        this.ownerPermissions = data.ownerPermissions;
        this.groupPermissions = data.groupPermissions;
        this.othersPermissions = data.othersPermissions;
    }
}
exports.FileSystemResourcePermissionMask = FileSystemResourcePermissionMask;
class RestApplicationClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * HTTP POST /v1/session/{path}
     * Java method: com.ionos.beat.waasdirectoryservice.v1.WaasDirectoryServiceApi.createResource
     */
    createResource(path, files, options) {
        return this.httpClient.request({ method: "POST", url: uriEncoding `v1/session/${path}`, data: files, options: options });
    }
    /**
     * HTTP DELETE /v1/session/{path}
     * Java method: com.ionos.beat.waasdirectoryservice.v1.WaasDirectoryServiceApi.deleteResource
     */
    deleteResource(path, options) {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding `v1/session/${path}`, options: options });
    }
    /**
     * HTTP GET /v1/session/{path}
     * Java method: com.ionos.beat.waasdirectoryservice.v1.WaasDirectoryServiceApi.getJsonResource
     */
    getJsonResource(path, options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `v1/session/${path}`, options: options });
    }
    /**
     * HTTP GET /v1/session/{path}
     * Java method: com.ionos.beat.waasdirectoryservice.v1.WaasDirectoryServiceApi.getPlainResource
     */
    getPlainResource(path, options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `v1/session/${path}`, options: options });
    }
    /**
     * HTTP GET /v1/session/{path}
     * Java method: com.ionos.beat.waasdirectoryservice.v1.WaasDirectoryServiceApi.getPlainResourceStream
     */
    getPlainResourceStream(path, options) {
        return this.httpClient.request({ method: "GET", url: uriEncoding `v1/session/${path}`, options: options });
    }
    /**
     * HTTP PUT /v1/session/{path}
     * Java method: com.ionos.beat.waasdirectoryservice.v1.WaasDirectoryServiceApi.updateResource
     */
    updateResource(path, fileSystemResource, options) {
        return this.httpClient.request({ method: "PUT", url: uriEncoding `v1/session/${path}`, data: fileSystemResource, options: options });
    }
}
exports.RestApplicationClient = RestApplicationClient;
function uriEncoding(template, ...substitutions) {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}
// Added by 'AxiosClientExtension' extension
const axios_1 = require("axios");
class AxiosHttpClient {
    constructor(axios) {
        this.axios = axios;
    }
    request(requestConfig) {
        function assign(target, source) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }
        const config = {};
        config.method = requestConfig.method; // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;
        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                axiosResponse.originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}
class AxiosRestApplicationClient extends RestApplicationClient {
    constructor(baseURL, axiosInstance = axios_1.default.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
exports.AxiosRestApplicationClient = AxiosRestApplicationClient;
//# sourceMappingURL=waas-directory-service-api.js.map